import { PiCallBell } from "react-icons/pi";

interface BellTriggerProps {
  setIsOpen: (isOpen: boolean) => void;
}

export const Trigger = ({ setIsOpen }: BellTriggerProps) => {
  return (
    <button
      onClick={() => setIsOpen(true)}
      className="chatbot-trigger-button bg-red-500 text-white p-4 rounded-full shadow-lg transition-colors flex items-center justify-center"
    >
      <PiCallBell size={24} />
    </button>
  );
};
